import Default from "../Component/Dashboard/Default/Default.svelte";
import Ecommerce from "../Component/Dashboard/Ecommerce/Ecommerce.svelte";
import General from "../Component/Widgets/General/General.svelte";
import Chart from "../Component/Widgets/Chart/Chart.svelte";
import Boxed from "../Component/PageLayout/BoxLayout/Boxed.svelte";
import RtlLayout from "../Component/PageLayout/RtlLayout/RtlLayout.svelte";
import DarkLayout from "../Component/PageLayout/DarkLayout/DarkLayout.svelte";
import FooterLight from "../Component/PageLayout/FooterLight/FooterLight.svelte";
import FooterDark from "../Component/PageLayout/FooterDark/FooterDark.svelte";
import FooterFixed from "../Component/PageLayout/FooterFixed/FooterFixed.svelte";
import Typography from "../Component/Ui-Kits/Typography/Typography.svelte";
import Avatars from "../Component/Ui-Kits/Avtars/Avatars.svelte";
import Grid from "../Component/Ui-Kits/Grid/Grid.svelte";
import TagPills from "../Component/Ui-Kits/TagPills/TagPills.svelte";
import HelperClasses  from "../Component/Ui-Kits/Helper-classes/HelperClasses.svelte";
import Navs from "../Component/Ui-Kits/Navs/Navs.svelte";
import Shadow from "../Component/Ui-Kits/Shadow/Shadow.svelte";
import Lists from "../Component/Ui-Kits/Lists/Lists.svelte" 
import Popover from "../Component/Ui-Kits/Popover/Popover.svelte";
import Tooltip from "../Component/Ui-Kits/Tooltips/Tooltips.svelte"
import Spinners  from "../Component/Ui-Kits/Spinners/Spinners.svelte";
import Dropdown from "../Component/Ui-Kits/Dropdown/Dropdown.svelte"
import Accordion from "../Component/Ui-Kits/Accordion/Accordion.svelte";
import BootstrapTabs from "../Component/Ui-Kits/Tabs/BootstrapTabs/BootstrapTabs.svelte";
import LineTabs from "../Component/Ui-Kits/Tabs/LineTabs/LineTabs.svelte"
import ProgressBar from "../Component/Ui-Kits/Progress/ProgressBar.svelte"
import Modal from "../Component/Ui-Kits/Modal/Modal.svelte";
import Alert from "../Component/Ui-Kits/Alert/Alert.svelte";
import Scrollable from "../Component/BonusUi/Scrollable/Scrollable.svelte";
import DefaultStyle from "../Component/Buttons/DefaultStyle/DefaultStyle.svelte"
import FlatStyle from "../Component/Buttons/FlatStyle/FlatStyle.svelte"
import EdgeStyle from "../Component/Buttons/EdgeStyle/EdgeStyle.svelte"
import RaisedStyle from "../Component/Buttons/RaisedStyle/RaisedStyle.svelte"
import ButtonGroup from "../Component/Buttons/ButtonGroup/ButtonGroup.svelte"
import Flagicon from "../Component/Icons/Flagicon/Flagicon.svelte"
import FontawesomeIcon from "../Component/Icons/FontawesomeIcon/FontawesomeIcon.svelte"
import IcoIcon from "../Component/Icons/IcoIcons/IcoIcons.svelte"
import ThemifyIcons from "../Component/Icons/ThemifyIcons/ThemifyIcons.svelte"
import FeatherIcon from "../Component/Icons/FeatherIcons/FeatherIcons.svelte"
import WhetherIcon from "../Component/Icons/WhetherIcon/WhetherIcon.svelte"
import Dropzone from "../Component/BonusUi/Dropzone/Dropzone.svelte";
import Toaster from "../Component/BonusUi/Toaster/Toaster.svelte"
import Rating from "../Component/BonusUi/Rating/Rating.svelte"
import SweetAlert from "../Component/BonusUi/SweetAlert/SweetAlert.svelte"
import Ribbons from "../Component/BonusUi/Ribbons/Ribbons.svelte"
import Pagination from "../Component/BonusUi/Pagination/Pagination.svelte"
import OwlCarousel from "../Component/BonusUi/SvelteSlider/Slider.svelte"
import Breadcrumb from "../Component/BonusUi/Breadcrumb/Breadcrumb.svelte"
import RangeSlider from "../Component/BonusUi/RangeSlider/RangeSlider.svelte"
import DraggableCards from "../Component/BonusUi/DraggableCards/DraggableCards.svelte"
import Step from "../Component/BonusUi/Step/Step.svelte"
import Treeview from "../Component/BonusUi/TreeView/TreeView.svelte"
import ImageCropper from "../Component/BonusUi/ImageCropper/ImageCropper.svelte"
import BasicCard from "../Component/BonusUi/BasicCard/BasicCard.svelte"
import CreativeCard from "../Component/BonusUi/CreativeCard/CreativeCard.svelte"
import TabbedCard from "../Component/BonusUi/TabbedCard/TabbedCard.svelte"
import Sticky from "../Component/BonusUi/Sticky/Sticky.svelte";
import TimeLine from "../Component/BonusUi/TimeLine/TimeLine.svelte"
import GalleryGrid from "../Component/Miscellaneous/Gallery/GalleryGrid/GalleryGrid.svelte"
import GalleryGridDesc from "../Component/Miscellaneous/Gallery/GalleryGridDesc/GalleryGridDesc.svelte"
import HoverEffects from "../Component/Miscellaneous/Gallery/HoverEffects/HoverEffects.svelte"
import BlogDetails from "../Component/Miscellaneous/Blog/BlogDetails/BlogDetails.svelte"
import BlogSingle from "../Component/Miscellaneous/Blog/BlogSingle/BlogSingle.svelte"
import AddPost from "../Component/Miscellaneous/Blog/AddPost/AddPost.svelte"
import FAQ from "../Component/Miscellaneous/FAQ/FAQ.svelte"
import SupportTicket from "../Component/Miscellaneous/SupportTicket/SupportTicket.svelte"
import LeafletMap from "../Component/Miscellaneous/LeafletMap/LeafletMap.svelte"
import Knowledgebase from "../Component/Miscellaneous/Knowledgebase/Knowledgebase/Knowledgebase.svelte"
import KnowledgeCategory from "../Component/Miscellaneous/Knowledgebase/KnowledgeCategory/KnowledgeCategory.svelte"
import KnowledgeDetail from "../Component/Miscellaneous/Knowledgebase/KnowledgeDetail/KnowledgeDetail.svelte"
import CardsView from "../Component/Miscellaneous/JobSearch/CardsView/CardsView.svelte"
import ListView from "../Component/Miscellaneous/JobSearch/ListView/ListView.svelte"
import JobDetails from "../Component/Miscellaneous/JobSearch/JobDetails/JobDetails.svelte"
import Apply from "../Component/Miscellaneous/JobSearch/Apply/Apply.svelte"
import LearningList from "../Component/Miscellaneous/LearningList/LearningList.svelte"
import DetailedCourse from "../Component/Miscellaneous/LearningList/DetailedCourse/DetailedCourse.svelte"
import SamplePages from "../Component/Pages/SamplePage/SamplePage.svelte"
import Product from "../Component/Application/Ecommerce/Product/Product.svelte"
import ProductPage from "../Component/Application/Ecommerce/ProductsPage/ProductsPage.svelte"
import Invoice from "../Component/Application/Ecommerce/Invoice/Invoice.svelte"
import Cart from "../Component/Application/Ecommerce/Cart/Cart.svelte"
import Checkout from "../Component/Application/Ecommerce/Checkout/Checkout.svelte"
import Pricing from "../Component/Application/Ecommerce/Pricing/Pricing.svelte"
import WishList from "../Component/Application/Ecommerce/Wishlist/Wishlist.svelte"
import PaymentDetails from "../Component/Application/Ecommerce/PaymentDetails/PaymentDetails.svelte";
import ProductList from "../Component/Application/Ecommerce/ProductList/ProductList.svelte"
import OrderHistory from "../Component/Application/Ecommerce/OrderHistory/OrderHistory.svelte"
import Contacts from "../Component/Application/Contacts/Contacts.svelte"
import Tasks from "../Component/Application/Tasks/Tasks.svelte"
import UsersProfile from "../Component/Application/Users/UserProfile/UserProfile.svelte"
import UserEditProfile from "../Component/Application/Users/UserEditProfile/UserEditProfile.svelte"
import UserCards from "../Component/Application/Users/UserCards/UserCards.svelte"
import Bookmarks from "../Component/Application/Bookmarks/Bookmarks.svelte"
import Todo from "../Component/Application/Todo/Todo.svelte"
import SearchResult from "../Component/Application/SearchResult/SearchResult.svelte"
import SocialApp from "../Component/Application/SocialApp/SocialApp.svelte"
import MailBox from "../Component/Application/Email/MailBox/MailBox.svelte"
import ReadEmail from "../Component/Application/Email/ReadEmail/ReadEmail.svelte"
import EmailCompose from "../Component/Application/Email/EmailCompose/EmailCompose.svelte"
import ChatApp from "../Component/Application/Chat/ChatApp/ChatApp.svelte"
import VideoChat from "../Component/Application/Chat/VideoChat/VideoChat.svelte"
import ProjectList from "../Component/Application/Project/ProjectList/ProjectList.svelte"
import CreateNew from "../Component/Application/Project/CreateNew/CreateNew.svelte"
import FileManager from "../Component/Application/FileManger/FileManger.svelte"
import BasicTable from "../Component/Table/SveltestrapTables/BasicTable/BasicTable.svelte"
import SizingTables from "../Component/Table/SveltestrapTables/SizingTables/SizingTables.svelte"
import BorderTables from "../Component/Table/SveltestrapTables/BorderTables/BorderTables.svelte"
import StylingTables from "../Component/Table/SveltestrapTables/StylingTables/StylingTables.svelte"
import DataTables from "../Component/Table/DataTable/DataTable.svelte";
import TableComponents from "../Component/Table/SveltestrapTables/TableComponents/TableComponents.svelte"
import FormValidation from "../Component/Forms/FormControls/FormValidation/FormValidation.svelte"
import BaseInputs from "../Component/Forms/FormControls/BaseInputs/BaseInputs.svelte"
import CheckboxRadio from "../Component/Forms/FormControls/Checkbox&Radio/CheckboxRadio.svelte"
import InputGroups from "../Component/Forms/FormControls/InputGroups/InputGroups.svelte"
import MegaOptions from "../Component/Forms/FormControls/MegaOptions/MegaOptions.svelte"
import FormDefault from "../Component/Forms/LayoutForms/FormDefault/FormDefault.svelte"
import FormWizard from "../Component/Forms/LayoutForms/FormWizard/FormWizard.svelte"
import Datepicker from "../Component/Forms/FormWidgets/DatePicker/DatePicker.svelte"
import TimePicker from "../Component/Forms/FormWidgets/TimePicker/TimePicker.svelte"
import DateTimePicker from "../Component/Forms/FormWidgets/DateTimePicker/DateTimePicker.svelte"
import Switch from "../Component/Forms/FormWidgets/Switch/Switch.svelte"
import ClipBoard from "../Component/Forms/FormWidgets/ClipBoard/ClipBoard.svelte"
import Typeahead from "../Component/Forms/FormWidgets/Typeahead/Typeahead.svelte"
import Select2 from "../Component/Forms/FormWidgets/Select2/Select2.svelte"
import ApexChart from "../Component/Charts/ApexChart/ApexChart.svelte"
import ChartJsChart from "../Component/Charts/ChartJSChart/ChartJSChart.svelte"
export default [
    {path:`/dashboard/default`, component: Default},
    {path:`/dashboard/ecommerce`, component:Ecommerce},

    {path:`/widgets/general`, component:General},
    {path:`/widgets/chart`, component:Chart },

    {path:`/pagelayout/boxed`, component:Boxed },
    {path:`/pagelayout/rtl`, component:RtlLayout },
    {path:`/pagelayout/dark`, component:DarkLayout },
    {path:`/pagelayout/footerlight`, component:FooterLight },
    {path:`/pagelayout/footerdark`, component:FooterDark },
    {path:`/pagelayout/footerfixed`, component:FooterFixed },

    {path:`/uikits/typography`, component:Typography},
    {path:`/uikits/avatars`, component:Avatars},
    {path:`/uikits/helperclasses`, component:HelperClasses},
    {path:`/uikits/progressbar`, component:ProgressBar},
    {path:`/uikits/modal`, component:Modal},
    {path:`/uikits/alert`, component:Alert},
    {path:`/uikits/grid`, component:Grid},
    {path:`/uikits/tag&pills`, component:TagPills},
    {path:`/uikits/helpersclasses`, component:HelperClasses},
    {path:`/uikits/navs`, component:Navs},
    {path:`/uikits/shadow`, component:Shadow},
    {path:`/uikits/lists`, component:Lists},
    {path:`/uikits/popover`, component:Popover},
    {path:`/uikits/tooltip`, component:Tooltip},
    {path:`/uikits/spinners`, component:Spinners},
    {path:`/uikits/dropdown`, component:Dropdown},
    {path:`/uikits/accordion`, component:Accordion},
    {path:`/uikits/tabs/sveltestraptabs`, component:BootstrapTabs},
    {path:`/uikits/tabs/linetabs`, component:LineTabs},

    {path:`/bonusui/scrollable`, component:Scrollable},
    {path:`/bonusui/treeview`, component:Treeview},
    {path:`/bonusui/basiccard`, component:BasicCard},
    {path:`/bonusui/creativecard`, component:CreativeCard},
    {path:`/bonusui/tabbedcard`, component:TabbedCard},
    {path:`/bonusui/dropzone`, component:Dropzone},
    {path:`/bonusui/toaster`, component:Toaster},
    {path:`/bonusui/rating`, component:Rating},
    {path:`/bonusui/sticky`, component:Sticky},
    {path:`/bonusui/imagecropper`, component:ImageCropper},
    {path:`/bonusui/sweetalert`, component:SweetAlert},
    {path:`/bonusui/ribbons`, component:Ribbons},
    {path:`/bonusui/pagination`, component:Pagination},
    {path:`/bonusui/step`, component:Step},
    {path:`/bonusui/owlcarousel`, component:OwlCarousel},
    {path:`/bonusui/breadcrumb`, component:Breadcrumb},
    {path:`/bonusui/rangeslider`, component:RangeSlider},
    {path:`/bonusui/draggablecard`, component:DraggableCards},
    {path:`/bonusui/timeline`, component:TimeLine},   
    {path:`/bonusui/scrollable`, component:Scrollable},
    {path:`/buttons/defaultstyle`, component:DefaultStyle},
    {path:`/buttons/flatstyle`, component:FlatStyle},
    {path:`/buttons/edgestyle`, component:EdgeStyle},
    {path:`/buttons/raisedstyle`, component:RaisedStyle},
    {path:`/buttons/buttongroup`, component:ButtonGroup},
    {path:`/bonusui/timeline`, component:TimeLine},
    {path:`/bonusui/scrollable`, component:Scrollable},

    {path:`/icons/flagicon`, component:Flagicon},
    {path:`/icons/fontawesomeicon`, component:FontawesomeIcon},
    {path:`/icons/icoicon`, component:IcoIcon},
    {path:`/icons/themifyicon`, component:ThemifyIcons},
    {path:`/icons/feathericon`, component:FeatherIcon},
    {path:`/pages/samplepage`, component:SamplePages},
    {path:`/icons/whethericon`, component:WhetherIcon},
    {path:`/gallery/gallerygrid`, component:GalleryGrid},
    {path:`/gallery/gallerygriddesc`, component:GalleryGridDesc},
    {path:`/gallery/hovereffects`, component:HoverEffects},
    {path:`/blog/blogdetails`, component:BlogDetails},
    {path:`/blog/blogsingle`, component:BlogSingle},
    {path:`/blog/addpost`, component:AddPost},
    {path:`/jobsearch/cardsview`, component:CardsView},
    {path:`/jobsearch/listview`, component:ListView},
    {path:`/jobsearch/jobdetails`, component:JobDetails},
    {path:`/jobsearch/apply`, component:Apply},
    {path:`/faq` , component:FAQ},
    {path:`/map/leafletmap`, component:LeafletMap},
    {path:`/learning/learninglist`, component:LearningList},
    {path:`/knowledge/knowledgebase`, component:Knowledgebase},
    {path:`/knowledge/knowledgecategory`, component:KnowledgeCategory},
    {path:`/knowledge/knowledgedetail`, component:KnowledgeDetail},
    {path:`/supportticket`, component:SupportTicket},
    {path:`/learning/detailedcourse`, component:DetailedCourse},

    {path:`/ecommerce/product`, component:Product},
    {path:`/ecommerce/productpage`, component:ProductPage },
    {path:`/ecommerce/productlist`, component:ProductList},
    {path:`/ecommerce/paymentdetails`, component:PaymentDetails},
    {path:`/ecommerce/orderhistory`, component:OrderHistory},
    {path:`/ecommerce/invoice`, component:Invoice},
    {path:`/ecommerce/cart`, component:Cart},
    {path:`/ecommerce/wishlist`, component:WishList},
    {path:`/ecommerce/checkout`, component:Checkout},
    {path:`/ecommerce/pricing`, component:Pricing},
    {path:`/apps/contacts`, component:Contacts},
    {path:`/users/usersprofile`, component:UsersProfile},
    {path:`/users/userscards`, component:UserCards},
    {path:`/users/usersedit`, component:UserEditProfile},
    {path:`/apps/bookmarks`, component:Bookmarks},
    {path:`/apps/todo`, component:Todo},
    {path:`/apps/searchresult`, component:SearchResult},
    {path:`/apps/socialapp`, component:SocialApp},
    {path:`/apps/tasks`, component:Tasks},
    {path:`/email/mailinbox`, component:MailBox},
    {path:`/email/readmail`, component:ReadEmail},
    {path:`/email/compose`, component:EmailCompose},
    {path:`/chat/chatapp`, component:ChatApp},
    {path:`/chat/videochat`, component:VideoChat},
    {path:`/project/projectlist`, component:ProjectList},
    {path:`/project/createnew` , component:CreateNew},
    {path:`/application/filemanager`, component:FileManager},
    {path:`/sveltestraptable/basictables`, component:BasicTable},
    {path:`/sveltestraptable/sizingtables`, component:SizingTables},
    {path:`/sveltestraptable/bordertables`, component:BorderTables},
    {path:`/sveltestraptable/stylingtables`, component:StylingTables},
    {path:`/sveltestraptable/tablecomponents`, component:TableComponents},
    {path:`/table/datatable`, component:DataTables},
    {path:`/formcontrols/formvalidation`, component:FormValidation},
    {path:`/formcontrols/baseinputs`, component:BaseInputs},
    {path:`/formcontrols/checkboxradio` ,component:CheckboxRadio},
    {path:`/formcontrols/inputgroups` , component:InputGroups} ,
    {path:`/formcontrols/megaoptions`, component:MegaOptions},
    {path:`/formlayout/defaultforms`, component:FormDefault},
    {path:`/formlayout/formwizard`, component:FormWizard},
    {path:`/formwidgets/datepicker`, component:Datepicker},
    {path:`/formwidgets/timepicker`, component:TimePicker},
    {path:`/formwidgets/datetimepicker`, component:DateTimePicker},
    {path:`/formwidgets/switch`, component:Switch},
    {path:`/formwidgets/clipboard`, component:ClipBoard},
    {path:`/formwidgets/typeahead` , component:Typeahead},
    {path:`/formwidgets/select2`, component:Select2},
    {path:`/charts/apexchart`, component:ApexChart},
    {path:`/charts/chatjschart`, component:ChartJsChart}
];
